import React, { useEffect, useState } from 'react';
import { useSettings } from '@/contexts/SettingsContext';
import { MessageCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const WhatsAppButton = () => {
  const { settings } = useSettings();
  const [tooltip, setTooltip] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setTooltip(false), 6500);
    return () => clearTimeout(t);
  }, []);

  if (!settings?.whatsapp_number) return null;
  const phone = String(settings.whatsapp_number).replace(/[^0-9]/g, '');
  const msg = encodeURIComponent(settings.whatsapp_message || 'Hi Smithy Browns!');
  const href = `https://wa.me/${phone}?text=${msg}`;

  return (
    <div className="fixed z-50 right-4 sm:right-6" style={{ bottom: 'calc(80px + env(safe-area-inset-bottom))' }} data-testid="whatsapp-floating-button">
      <div className="hidden lg:block absolute bottom-0 right-0" style={{ bottom: 'auto', position: 'static' }} />
      <div className="relative">
        <AnimatePresence>
          {tooltip && (
            <motion.div
              initial={{ opacity: 0, y: 10, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.25 }}
              className="absolute bottom-full right-0 mb-3 w-64 sb-card p-3 pr-7 shadow-xl"
            >
              <button onClick={() => setTooltip(false)} className="absolute top-1.5 right-1.5 text-white/55 hover:text-white"><X size={12} /></button>
              <div className="font-display text-sm text-white">NEED HELP?</div>
              <div className="text-xs text-white/75 mt-0.5">Message us on WhatsApp — we usually reply within minutes.</div>
              <div className="absolute -bottom-1.5 right-6 w-3 h-3 rotate-45 bg-[hsl(var(--sb-card))] border-r border-b border-[hsl(var(--sb-border))]" />
            </motion.div>
          )}
        </AnimatePresence>
        <motion.a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Message us on WhatsApp"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          whileHover={{ scale: 1.08, rotate: -2 }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: 'spring', stiffness: 280, damping: 18 }}
          className="relative inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-2xl shadow-[#25D366]/30 hover:bg-[#1FB855] focus:outline-none focus:ring-4 focus:ring-[#25D366]/40"
        >
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
          <MessageCircle size={26} fill="white" />
        </motion.a>
      </div>
    </div>
  );
};
